// Considered: DialogWrapper directly — rejected because this wraps it with feature-specific copy and a fixed two-button layout, reused from the overlay editor and structural-change detector call sites. See spec Reuse Audit.
import React, { useCallback } from 'react';
import { useTranslation } from 'localization';
import './ForkMetaspacePromptMolecule.scss';

export interface ForkMetaspacePromptMoleculeProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ForkMetaspacePromptMolecule: React.FC<ForkMetaspacePromptMoleculeProps> = ({
  open,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const { t } = useTranslation();

  const handleOverlayClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget && !loading) onCancel();
    },
    [loading, onCancel]
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Escape' && !loading) onCancel();
    },
    [loading, onCancel]
  );

  if (!open) return null;

  return (
    <div
      className="marketplace-dialog-overlay marketplace-fork-prompt-overlay"
      onClick={handleOverlayClick}
      onKeyDown={handleKeyDown}
    >
      <div
        className="marketplace-dialog marketplace-fork-metaspace-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="fork-metaspace-dialog-title"
      >
        <div className="marketplace-dialog__header">
          <h2 id="fork-metaspace-dialog-title" className="marketplace-dialog__title">
            {t('sphereMetaspaces.fork.title')}
          </h2>
        </div>

        <div className="marketplace-dialog__body marketplace-fork-metaspace-dialog__body">
          <p className="marketplace-fork-metaspace-dialog__description">
            {t('sphereMetaspaces.fork.description')}
          </p>
        </div>

        <div className="marketplace-dialog__actions">
          <button
            type="button"
            className="marketplace-dialog__cancel-btn"
            onClick={onCancel}
            disabled={loading}
          >
            {t('sphereMetaspaces.fork.cancel')}
          </button>
          <button
            type="button"
            className="marketplace-dialog__submit-btn"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading
              ? t('sphereMetaspaces.fork.forking')
              : t('sphereMetaspaces.fork.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

ForkMetaspacePromptMolecule.displayName = 'ForkMetaspacePromptMolecule';

export default ForkMetaspacePromptMolecule;
